import React, { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';

import { fetchOne } from '../../lib/v31lib';
import { fetch_with_count } from '../../lib/server_helper';
import { loginAtom } from '../../lib/auth';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';

// import {
//   Grid,
// } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  DataGrid,
  Page,
  StyledButton,
  StyledIconButton,
} from '../../components/interface';
import { AlertDestroyed } from '../../components/alerts/Destroyed';
import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import {
  InvestmentManager
} from '../../models';

// const { DateTime } = require("luxon");

type Props = {};

export const InvestmentManagers: FunctionComponent<Props> = () => {
  const navigate = useNavigate();
  // const theme = useTheme();
  
  const [login, setLogin] = useAtom(loginAtom);
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("name ASC");
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);
  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);

  let count = 0;

  const {
    data: objects,
    isLoading: objectsLoading,
    // isError: adviceUploadsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["investment_managers", {page: page, order: order}],
    queryFn: () =>
      fetch_with_count<InvestmentManager>(
        `/nl/v3/objects/fetch_all`,
        {
          object: 'investment_manager',
          fields: ['id', 'created_at', 'name', 'contact_name', 'contact_email'],
          per_page: 10,
          page: page,
          order: order,
          filter: {
            advanced: {
              placeholder: 0
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    // enabled: false,
  });


  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 100, sortable: true },
    { field: 'name', headerName: 'Name', width: 250, sortable: false },
  ];











  const mutationDestroy = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetchOne<InvestmentManager>(
        `/nl/v3/objects/remove`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setDestroyedOpen(true);
      objectsRefetch();
    },
  });








  // useEffect(() => {
  //   getBookYears();
  // }, [login]);











  return <Page sx={{}} title="Investment Managers" helper="investment_managers" actions={<>
    <StyledButton
      label="Create new"
      id='create_new'
      contained
      onClick={() => {
        navigate("/internal/investment_manager/new");
      }}
      sx={{marginRight: 3}}
      startIcon={<AddCircleOutlineIcon />}
    />
  </>}>
    <DataGrid
      action_count={2}
      actions={(params) => {
        return (<>
          <StyledIconButton color="primary" path={`/internal/investment_manager/${params.row.id}`}>
            <VisibilityIcon />
          </StyledIconButton>
          {!mutationDestroy.isPending && <StyledIconButton title="Remove" destroyBtn color="secondary" onClick={() => {
            mutationDestroy.mutate({
              formData: {
                object: 'investment_manager',
                id: params.row.id,
                ob: {
                  id: params.row.id,
                }
              }
            });
          }}>
            <DeleteIcon />
          </StyledIconButton>}
        </>);
      }}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objectCount={count}
      objects={(objects || []).map(u => ({
        ...u,
        count: 0,
        pdfs: 0
      }))}
      columns={columns}
      loader={objectsLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        setOrder([a_0_field, a[0].sort].join(' '));
      }}
      page={page}
      setPage={(p) => {setPage(p);}}
    />

    {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
    {!!destroyedOpen && <AlertDestroyed open={destroyedOpen} setOpen={setDestroyedOpen} />}
  </Page>;
}
